import { render, staticRenderFns } from "./addDep.vue?vue&type=template&id=71d14a23"
import script from "./addDep.vue?vue&type=script&lang=js"
export * from "./addDep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports